import { createQueryParams, readQueryParams } from '@cp/src/utils/QueryParamsHelper';
import { AnomalyActionTabsKey, AnomalyTableKeys } from './types';
import ETA from './components/ETA';
import RCA from './components/RCA';
import ResolveAnomaly from './components/ResolveAnomaly';

export const getAssignedToName = (assignedTo: string, isAssignedToYou: boolean) => {
  if (!assignedTo) return '-';
  if (isAssignedToYou) return `You (${assignedTo})`;
  return assignedTo;
};

export const getAnomalyActionUrl = (anomalyReferenceId: string) => {
  const params = readQueryParams();
  const updatedTableParams = {
    ...params,
    [AnomalyTableKeys.ANOMALY_TABLE_ACTION]: {
      ...params[AnomalyTableKeys.ANOMALY_TABLE_ACTION],
      selectedId: anomalyReferenceId
    }
  };
  const url = createQueryParams(updatedTableParams);
  return url;
};

export const getNameDetailsWithNo = (name: string, phoneNo: string) => {
  if (name && phoneNo) {
    return `${name} (${phoneNo})`;
  }
  if (name) return name;
  return null;
};

export const getAnomalyActionTabs = (enableAnomalyTrackerResolution: boolean) => {
  const actionTabs = [
    {
      key: AnomalyActionTabsKey.RCA,
      value: 'RCA',
      component: <RCA />
    },
    {
      key: AnomalyActionTabsKey.ETA,
      value: 'ETA',
      component: <ETA />
    }
  ];

  if (enableAnomalyTrackerResolution) {
    actionTabs.push({
      key: AnomalyActionTabsKey.RESOLVE_ANOMALY,
      value: 'Resolve Anomaly',
      component: <ResolveAnomaly />
    });
  }
  return actionTabs;
};
